import { Field } from '~/features/document-handler/types/fields';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

import { Field as ApiFieldType } from './types';

interface Request {
  documentId: PilotId;
  fields: Array<{
    id: PilotId;
    label: string;
    value: any;
  }>;
}

type Response = Array<{ value: ApiFieldType['value']; id: PilotId }>;

export const putDocumentUpdate = async (
  params: Request,
): Promise<Pick<Field, 'id' | 'value'>[]> => {
  const { documentId, fields } = params;

  const response: Response = await pilot.put(`/document/update/${documentId}`, [
    ...fields,
  ]);

  return response.map((field) => ({
    id: field.id,
    value: field.value
      ? Array.isArray(field.value)
        ? field.value.map((v) => ({
            displayValue: v.display_value,
            value: v.value,
          }))
        : {
            displayValue: field.value.display_value,
            value: field.value.value,
          }
      : field.value,
  })) as Pick<Field, 'id' | 'value'>[];
};
